import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import pick from 'lodash/pick';
import { connect } from 'react-redux';
import { SimpleLoadingComponent } from '../../utils/apollo';
import ChangeProfilePage from './change-profile';

const fragments = gql`
  fragment profileFields on HSAccount {
    id
    primaryUser {
      id
      firstName
      lastName
      email
      active
      role
      lockStatus
    }
    userList {
      id
      firstName
      lastName
      email
      active
      role
      lockStatus
    }
  }
`;

const updateHSAccountMutation = gql`
  mutation updateHSAccount($input: updateHSAccountInput!) {
    updateHSAccount(input: $input) {
      hsAccount {
          ...profileFields
        }
      }
    }
    ${fragments}
    `;

const updateHSAccountMutateData = graphql(updateHSAccountMutation, {
  name: 'updateHSAccount',
});

const query = gql`
      query ProfilePage ($id: String!) {
      viewer {
        id
        enabledFeatures
        uuid
      }
        hsAccountByNcesid (id: $id) {
          ...profileFields
        }
      }
      ${fragments}
    `;

const graphqlData = graphql(query,
  {
    props: ({ data, ...rest }) => ({
      data,
      node: data.hsAccountByNcesid,
      ...rest,
    }),
    options: ({ current }) => {
      const id = current.viewer.idToken['custom:institution'];
      return {
        variables: {
          id,
        },
      };
    },
  });

const mapStateToProps = (state) => pick(state, 'current');

const container = connect(mapStateToProps)(SimpleLoadingComponent(graphqlData, updateHSAccountMutateData)(ChangeProfilePage));

export default container;
